'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment } from 'react';
import PropTypes from 'prop-types';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedDateTime from 'I18n/components/FormattedDateTime';
import FormattedName from 'I18n/components/FormattedName';
import HR from 'UIComponents/elements/HR';
import { ROOT_FONT_SIZE } from 'HubStyleTokens/sizes';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIAvatar from 'ui-addon-avatars/UIAvatar';
import Small from 'UIComponents/elements/Small';
import UIButton from 'UIComponents/button/UIButton';
import Reply from 'marketplace-ui-reviews/records/Reply';
import LegacyReply from '../../records/Reply';
const textPath = 'ecosystemMarketplaceCore.reviews.replyThread';

const ReviewReplyThread = ({
  reply: replyMap,
  onReportReplyClick,
  TagComponent,
  vrHidden = true
}) => {
  const {
    reply,
    repliedAt,
    replierDisplayName,
    avatarUrl,
    companyName
  } = replyMap;

  if (!reply) {
    return null;
  }

  const textKey = companyName ? 'title_jsx' : 'titleWithoutCompany_jsx';
  const displayName = replierDisplayName || I18n.text('ecosystemMarketplaceCore.reviews.defaultReplierName');
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx(HR, {}), TagComponent && /*#__PURE__*/_jsx(TagComponent, {}), /*#__PURE__*/_jsxs(UIFlex, {
      direction: "column",
      className: "p-left-12",
      children: [/*#__PURE__*/_jsxs(UIFlex, {
        align: "center",
        className: 'm-bottom-2' + (vrHidden ? " vr-hidden" : ""),
        children: [/*#__PURE__*/_jsx(UIAvatar, {
          size: "xs",
          src: avatarUrl
        }), /*#__PURE__*/_jsx("span", {
          style: {
            fontSize: ROOT_FONT_SIZE
          },
          className: "m-x-3",
          children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
            message: `${textPath}.${textKey}`,
            options: {
              displayName,
              companyName
            },
            elements: {
              Name: FormattedName,
              Bold: 'b'
            }
          })
        }), /*#__PURE__*/_jsx(Small, {
          children: /*#__PURE__*/_jsx(FormattedDateTime, {
            value: repliedAt,
            format: "ll",
            type: "userTz"
          })
        })]
      }), /*#__PURE__*/_jsx(UIFlex, {
        children: /*#__PURE__*/_jsx("span", {
          "data-test-id": "review-reply-text",
          children: reply
        })
      }), onReportReplyClick && /*#__PURE__*/_jsx(UIButton, {
        use: "link",
        className: "m-top-2",
        onClick: onReportReplyClick,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `${textPath}.report`
        })
      })]
    })]
  });
};

ReviewReplyThread.propTypes = {
  reply: PropTypes.oneOfType([PropTypes.instanceOf(LegacyReply), PropTypes.instanceOf(Reply)]).isRequired,
  onReportReplyClick: PropTypes.func,
  TagComponent: PropTypes.elementType,
  vrHidden: PropTypes.bool
};
export default ReviewReplyThread;